import React, {useState, useEffect, useRef} from 'react';
import propTypes from 'prop-types';
import styled from '@emotion/styled';
import { useMediaQuery } from '@mui/material';
import { theme } from '../../themes/default-theme';
import ModelLogo from '../../components/multimedia/ModelLogo';
import ModelFloorplan from '../../containers/ModelFloorplan';
import { useRouter } from 'next/router';

const Wrapper = styled.div`
    padding-left: 20px;
    padding-right: 20px;
    position: relative;
    background: ${theme.palette.lightGrey};
    display: inline-block;
    width: 100%;
    ${theme.breakpoints.up('lg')} {
        padding-left: 40px;
        padding-right: 40px;
    }
`
const Container = styled.div`
    max-width: 1400px;
    margin: auto;
    ${theme.breakpoints.up('md')} {

    }
`

const modelStepTwoFloorplanPageDefaultPropSeriesUrl = {};
const modelStepTwoFloorplanPageDefaultPropModelLogo = {};
const modelStepTwoFloorplanPageDefaultPropModelFloorplan = {};
const modelStepTwoFloorplanPageDefaultPropModelPrice = {};
const modelStepTwoFloorplanPageDefaultPropDealers = [];

const ModelStepTwoFloorplanPage = (props) => {
    props = {
        ...props,
        seriesName: typeof props.seriesName === "undefined" ? null : props.seriesName,
        seriesUrl: typeof props.seriesUrl === "undefined" ? modelStepTwoFloorplanPageDefaultPropSeriesUrl : props.seriesUrl,
        modelLogo: typeof props.modelLogo === "undefined" ? modelStepTwoFloorplanPageDefaultPropModelLogo : props.modelLogo,
        modelFloorplan: typeof props.modelFloorplan === "undefined" ? modelStepTwoFloorplanPageDefaultPropModelFloorplan : props.modelFloorplan,
        modelPrice: typeof props.modelPrice === "undefined" ? modelStepTwoFloorplanPageDefaultPropModelPrice : props.modelPrice,
        dealers: typeof props.dealers === "undefined" ? modelStepTwoFloorplanPageDefaultPropDealers : props.dealers,
        buildPriceDisclaimer: typeof props.buildPriceDisclaimer === "undefined" ? null : props.buildPriceDisclaimer,
        hasFloorplan: typeof props.hasFloorplan === "undefined" ? null : props.hasFloorplan
    };

    const {
        seriesName,
        seriesUrl,
        modelLogo,
        modelFloorplan,
        modelPrice,
        dealers,
        buildPriceDisclaimer,
        disablePrice,
        countryProps,
        hasFloorplan
    } = props

    const router = useRouter();
    const [showBuildAndPrice, setShowBuildAndPrice] = useState(true);

    // useEffect(() => {
    //     if((document.location.hostname == 'www.jaycoadelaide.com.au') || (document.location.hostname == 'www.jaycoalbertpark.com.au') || (document.location.hostname.indexOf('jayco-com-au.au1.staticlyproject.com') > -1) || (document.location.hostname.indexOf('localhost') > -1)) {
    //       setShowBuildAndPrice(true);
    //     } else {
    //       setShowBuildAndPrice(false);
    //       router.push('/404');
    //     }
    // }, [])

    // Media Breakpoint Start
    const desktopView = useMediaQuery(theme.breakpoints.up('md'));
    const mobileView = useMediaQuery(theme.breakpoints.down('sm'));
    // Media Breakpoint End
    // Set Dynamic Width
    const media = useMediaQuery(theme.breakpoints.up('0'));
    const ref = useRef(null);
    const ref2 = useRef(null);
    const [width, setWidth] = useState(0);
    const[containerWidth, setConntainerWidth] = useState(0);

    useEffect(() => {
        if (ref.current && ref.current.clientWidth) {
            setWidth(ref.current.clientWidth);
        }
        function handleWindowResize() {
            if (ref.current && ref.current.clientWidth) {
                setWidth(ref.current.clientWidth);
            }
        }
        window.addEventListener('resize', handleWindowResize);

        if (ref2.current && ref2.current.clientWidth) {
            setConntainerWidth(ref2.current.clientWidth);
        }
        function handleWindowResize2() {
            if (ref2.current && ref2.current.clientWidth) {
                setConntainerWidth(ref2.current.clientWidth);
            }
        }
        window.addEventListener('resize', handleWindowResize2);
        return () => {
            window.removeEventListener('resize', handleWindowResize);
            window.removeEventListener('resize', handleWindowResize2);
        };

    }, [media]);

    console.log('rrr', props)
    return (
        showBuildAndPrice &&
        <>
            <ModelLogo
                {...modelLogo}
            />
            <Wrapper ref={ref}>
                <div ref={ref2} style={{maxWidth: '1400px', margin: '0 auto', height: 0, overflow: 'hidden'}} />

                {/* <Container ref={ref2}> */}
                    <ModelFloorplan
                        {...modelFloorplan}
                        countryProps={countryProps}
                        dealers={dealers && dealers}
                        modelPrice={modelPrice}
                        currentWidth={(width - containerWidth)/2}
                        disablePrice={disablePrice}
                        buildPriceDisclaimer={buildPriceDisclaimer}
                    />
                {/* </Container> */}

            </Wrapper>
        </>
    )
}

ModelStepTwoFloorplanPage.propTypes = {
    seriesName: propTypes.string,
    seriesUrl: propTypes.object,
    modelLogo: propTypes.object,
    modelFloorplan: propTypes.object,
    modelPrice: propTypes.object,
    dealers: propTypes.array,
    buildPriceDisclaimer: propTypes.string,
    disablePrice: propTypes.bool,
    hasFloorplan: propTypes.bool
}

export default ModelStepTwoFloorplanPage